import {ICache} from '@src/@interfaces/classes/Cacheable/ICache';
import {ICommentModel} from '@src/@interfaces/models/Comment/ICommentModel';
import Cache from '@src/classes/Cacheable/Cache';
import CancelablePromise from '@src/classes/CancelablePromise/CancelablePromise';
import {ICommentResolver} from '@src/@interfaces/services/CommentRepository/ICommentResolver';
import {ICommentRepository} from '@src/@interfaces/services/CommentRepository/ICommentRepository';
import {ICommentsRequest} from '@src/@interfaces/services/CommentRepository/ICommentsRequest';
import CommentsRequest from '@src/services/CommentRepository/CommentsRequest';

class Wrapper extends CancelablePromise<ICommentModel> implements ICommentResolver {
}

export default class CommentRepository implements ICommentRepository {
    protected cache!: ICache<ICommentResolver>;

    protected lastRequest: ICommentsRequest | null = null;

    constructor() {
        this.cache = new Cache();
    }

    getById(id: string | number): ICommentResolver {
        const stringId = String(id);

        return this.cache.remember(
            stringId,
            () => this.resolveComment(stringId),
        );
    }

    flushCache() {
        this.cache.flushCache();
    }

    protected resolveComment(commentId: string): ICommentResolver {
        if (!this.lastRequest || !this.lastRequest.isAvailable()) {
            this.lastRequest = new CommentsRequest();
        }

        const request = this.lastRequest;
        const controls: { request?: ICommentsRequest } = {request};

        return new Wrapper(
            (resolve, reject) => {
                request
                    .push(commentId)
                    .then(comments => {
                        const comment = comments[commentId] ?? null;
                        if (comment) {
                            resolve(comment);
                        } else {
                            reject(new Error('Comment not found'));
                        }
                    })
                    .catch(reject)
                    .finally(() => {
                        if (this.lastRequest === controls.request) {
                            this.lastRequest = null;
                        }

                        controls.request = undefined;
                    });
            },
            () => controls.request?.forget(commentId),
        );
    }
}
